import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import commonReducer from '../features/common/redux/reducer';
import loginReducer from '../features/login/redux/reducer';
import schedulesReducer from '../features/schedules/redux/reducer';
import timeoffReducer from '../features/timeoff/redux/reducer';
import scorecardReducer from '../features/scorecard/redux/reducer';
import agentInfoVerificationReducer from '../features/agent-info-verification/redux/reducer';
import contestsReducer from '../features/contests/redux/reducer';
// import featureFlagReducer from '../features/common/redux/featureFlagReducer';
import agentCoachingReducer from '../features/agent-coaching/redux/reducer';

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage theme.

const reducerMap = {
  router: routerReducer,
  common: commonReducer,
  login: loginReducer,
  schedules: schedulesReducer,
  timeoff: timeoffReducer,
  scorecard: scorecardReducer,
  agentInfoVerification: agentInfoVerificationReducer,
  contests: contestsReducer,
  // verificationFeatureFlag: featureFlagReducer,
  agentCoaching: agentCoachingReducer
};

export default combineReducers(reducerMap);



// WEBPACK FOOTER //
// ./src/common/rootReducer.js